"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityNoteDto = instanceOfFacilityNoteDto;
exports.FacilityNoteDtoFromJSON = FacilityNoteDtoFromJSON;
exports.FacilityNoteDtoFromJSONTyped = FacilityNoteDtoFromJSONTyped;
exports.FacilityNoteDtoToJSON = FacilityNoteDtoToJSON;
exports.FacilityNoteDtoToJSONTyped = FacilityNoteDtoToJSONTyped;
const NoteAttachmentDto_1 = require("./NoteAttachmentDto");
/**
 * Check if a given object implements the FacilityNoteDto interface.
 */
function instanceOfFacilityNoteDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('note' in value) || value['note'] === undefined)
        return false;
    if (!('author' in value) || value['author'] === undefined)
        return false;
    if (!('authorId' in value) || value['authorId'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined)
        return false;
    if (!('attachments' in value) || value['attachments'] === undefined)
        return false;
    if (!('facility' in value) || value['facility'] === undefined)
        return false;
    return true;
}
function FacilityNoteDtoFromJSON(json) {
    return FacilityNoteDtoFromJSONTyped(json, false);
}
function FacilityNoteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'note': json['note'],
        'author': json['author'],
        'authorId': json['authorId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'attachments': (json['attachments'].map(NoteAttachmentDto_1.NoteAttachmentDtoFromJSON)),
        'facility': json['facility'],
    };
}
function FacilityNoteDtoToJSON(json) {
    return FacilityNoteDtoToJSONTyped(json, false);
}
function FacilityNoteDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'note': value['note'],
        'author': value['author'],
        'authorId': value['authorId'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'attachments': (value['attachments'].map(NoteAttachmentDto_1.NoteAttachmentDtoToJSON)),
        'facility': value['facility'],
    };
}
//# sourceMappingURL=FacilityNoteDto.js.map